import { render, staticRenderFns } from "./TasklistToolbar.vue?vue&type=template&id=2d6807ed"
import script from "./TasklistToolbar.vue?vue&type=script&lang=js"
export * from "./TasklistToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports